"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var ActionButtons = function ActionButtons(_ref) {
  var open = _ref.open,
      onEditClicked = _ref.onEditClicked,
      onDeleteClicked = _ref.onDeleteClicked,
      onMouseLeave = _ref.onMouseLeave,
      className = _ref.className,
      hideEditButton = _ref.hideEditButton;

  if (!open) {
    return _react.default.createElement("div", null);
  }

  return _react.default.createElement(_UIButtonGroup.default, {
    className: className,
    onMouseLeave: onMouseLeave
  }, !hideEditButton && _react.default.createElement(_UIButton.default, {
    onClick: onEditClicked,
    size: "extra-small",
    use: "tertiary",
    "data-selenium-test": "question-and-answer-component-edit-button"
  }, _react.default.createElement(_UIIcon.default, {
    name: "replace"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.edit"
  })), _react.default.createElement(_UIButton.default, {
    size: "extra-small",
    use: "tertiary",
    onClick: onDeleteClicked
  }, _react.default.createElement(_UIIcon.default, {
    name: "delete"
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.delete"
  })));
};

ActionButtons.propTypes = {
  open: _react.PropTypes.bool.isRequired,
  onEditClicked: _react.PropTypes.func,
  onDeleteClicked: _react.PropTypes.func.isRequired,
  onMouseLeave: _react.PropTypes.func.isRequired,
  className: _react.PropTypes.string.isRequired,
  hideEditButton: _react.PropTypes.bool.isRequired
};
var _default = ActionButtons;
exports.default = _default;
module.exports = exports.default;